<template>
  <div class="input-group">
    <input
      :id="id"
      :data-test-id="`input-${id}`"
      :class="`${classesInput} fundo-cinza`"
      :value="filtro.palavra"
      type="text"
      aria-haspopup="true"
      aria-expanded="false"
      @input="atualizarFiltroPalavra"
      @click="pesquisar()"
      @blur="blur()"
    />
    <div :class="{ active: mostrarLista }" class="buscar-selecionar">
      <ul class="dropdown-list" role="navigation">
        <li tabindex="0">
          <button
            :data-test-id="`button-${id}-anterior`"
            :disabled="filtro.pagina === 1"
            type="button"
            class="btn btn-default btn-sm btn-block botao-dropdown"
            @click="recuperarAnteriores()"
          >
            <span class="fa fa-chevron-up" />
          </button>
        </li>
        <li v-if="lista.length == 0"> Nenhum registro </li>
        <span
          v-for="item in lista"
          :key="item[itemId]"
          class="buscar-selecionar-item"
        >
          <span v-if="!ativo(item)">
            <li v-if="lista.length > 0" class="item-dropdown">
              <a
                v-for="exibe in exibir"
                :key="exibe"
                :data-test-id="`link-${id}-item-desabilitado`"
                class="desabilitado"
                style="display: block"
                href="#"
                @click.prevent=""
              >
                <strong v-if="exibirChave">{{ chave(exibe) }}</strong>
                {{ valor(item, exibe) }}
              </a>
            </li>
          </span>
          <span v-if="ativo(item)">
            <li v-if="lista.length > 0" class="item-dropdown">
              <span v-for="exibe in exibir" :key="exibe">
                <a
                  v-if="extrairValor(item, exibe)"
                  :data-test-id="`link-${id}-item`"
                  class="buscar-selecionar-item-texto"
                  style="display: block"
                  href="#"
                  @click.prevent="selecionarItem(item)"
                >
                  <strong v-if="exibirChave">{{ chave(exibe) }}</strong>
                  {{ valor(item, exibe) }}
                </a>
              </span>
            </li>
          </span>
        </span>
        <li>
          <button
            :data-test-id="`button-${id}-proximo`"
            :disabled="lista.length === 0"
            type="button"
            class="btn btn-default btn-sm btn-block botao-dropdown"
            @click="recuperarProximos()"
          >
            <span class="fa fa-chevron-down" />
          </button>
        </li>
      </ul>
    </div>
    <span
      :data-test-id="`button-${id}-limpar`"
      class="input-group-addon input-sm"
      @click="limpar()"
    >
      <span class="fa fa-times" />
    </span>
  </div>
</template>

<script>
const LIMITE = '5'

export default {
  name: 'BuscarSelecionar',
  props: {
    id: {
      type: String,
      default: 'buscar-selecionar',
    },
    lista: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
    selecionado: {
      type: [Object, String],
      required: true,
      default: () => {
        return {}
      },
    },
    minimo: {
      type: Number,
      required: false,
      default: 3,
    },
    exibir: {
      type: Array,
      required: false,
      default: () => {
        return ['nome']
      },
    },
    ativo: {
      type: Function,
      required: false,
      default: () => {
        return () => {
          return false
        }
      },
    },
    exibirChave: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
    classesInput: {
      type: String,
      required: false,
      default: () => {
        return 'form-control'
      },
    },
    itemId: {
      type: String,
      default: '_id',
    },
  },
  data() {
    return {
      filtro: {
        palavra: '',
        pagina: 1,
        limite: LIMITE,
      },
      mostrarLista: false,
    }
  },
  computed: {
    descricao() {
      if (this.exibir && this.selecionado) {
        const chave = this.exibir[0]

        if (typeof this.selecionado === 'object' && this.selecionado[chave]) {
          return this.selecionado[chave]
        }

        if (typeof this.selecionado === 'string' && this.selecionado) {
          return this.selecionado
        }
      }

      return ''
    },
  },
  watch: {
    descricao() {
      this.filtro.palavra = this.descricao
    },
  },
  created() {
    this.filtro.palavra = this.extrairDescricao()
  },
  methods: {
    atualizarFiltroPalavra(event) {
      this.filtro.palavra = event.target.value
      this.pesquisar()
    },
    chave(valor) {
      return this.extrairChave(valor)
    },
    valor(valor, atributo) {
      return this.extrairValor(valor, atributo)
    },
    extrairDescricao() {
      if (this.exibir && this.selecionado) {
        const chave = this.exibir[0]

        if (typeof this.selecionado === 'object' && this.selecionado[chave]) {
          return this.selecionado[chave]
        }

        if (typeof this.selecionado === 'string' && this.selecionado) {
          return this.selecionado
        }
      }

      return ''
    },
    extrairChave(valor) {
      let result = valor
      const arr = result.split('.')
      result = arr[arr.length - 1].toUpperCase()
      return result
    },
    extrairValor(valor, atributo) {
      return atributo.split('.').reduce((prev, curr) => {
        return prev ? prev[curr] : '-'
      }, valor || self)
    },
    recuperar() {
      this.$emit('recuperar', this.filtro)
    },
    limpar() {
      this.filtro.palavra = ''
      this.pesquisar()
      this.filtro.pagina = 1
      this.$emit('limpar')
      this.recuperar()
      this.mostrarLista = false
    },
    selecionarItem(item) {
      this.filtro.palavra = this.extrairValor(item, this.exibir[0])
      this.pesquisar()
      this.filtro.pagina = 1
      this.mostrarLista = false
      this.$emit('selecionar', item)
    },
    blur() {
      if (this.lista.length === 0) {
        this.mostrarLista = false
      }
    },
    pesquisar() {
      if (
        this.filtro.palavra.length >= this.minimo &&
        (this.filtro.palavra === '' || this.filtro.palavra !== this.descricao)
      ) {
        this.mostrarLista = true
        this.recuperar()
      } else {
        this.mostrarLista = false
        this.filtro.pagina = 1
      }
    },
    recuperarAnteriores() {
      this.filtro.pagina--
      this.recuperar()
    },
    recuperarProximos() {
      this.filtro.pagina++
      this.recuperar()
    },
  },
}
</script>

<style scoped>
.buscar-selecionar {
  position: relative;
  cursor: pointer;
  background-color: #fff !important;
}
.buscar-selecionar .header {
  z-index: 1;
  height: 37px;
  padding: 10px 15px;
  overflow: hidden;
}
.buscar-selecionar .search {
  z-index: 2;
  display: none;
  padding: 5px;
}
.buscar-selecionar .dropdown-list {
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  z-index: 5;
  display: none;
  width: 300px;
  padding: 0;
  margin: 40px 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: outside none none;
  background-color: white;
  border: 1px solid #e6e8ea;
}

.buscar-selecionar.active .search {
  display: inherit;
}

.buscar-selecionar.active .dropdown-list {
  display: inherit;
}

.buscar-selecionar-item-texto {
  color: #008080;
  text-decoration: none;
}

.buscar-selecionar-item-texto:hover {
  text-decoration: none;
}

.buscar-selecionar-item li {
  padding: 8px;
  background-color: white;
}

.buscar-selecionar-item li:hover {
  background-color: #e6e8ea;
}

.item-dropdown {
  border-bottom: 1px solid #e6e8ea;
}

.botao-dropdown {
  padding: 8px;
  font-size: 10px;
  border: none;
}

.desabilitado {
  color: #7b8a8b !important;
  cursor: not-allowed !important;
}

.fundo-cinza {
  background-color: #ecf0f1;
}
</style>
